import { render, staticRenderFns } from "./TotalCountPanel.vue?vue&type=template&id=437ef8f3&scoped=true&"
import script from "./TotalCountPanel.vue?vue&type=script&lang=js&"
export * from "./TotalCountPanel.vue?vue&type=script&lang=js&"
import style0 from "./TotalCountPanel.vue?vue&type=style&index=0&id=437ef8f3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ef8f3",
  null
  
)

/* custom blocks */
import block0 from "./TotalCountPanel.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437ef8f3')) {
      api.createRecord('437ef8f3', component.options)
    } else {
      api.reload('437ef8f3', component.options)
    }
    module.hot.accept("./TotalCountPanel.vue?vue&type=template&id=437ef8f3&scoped=true&", function () {
      api.rerender('437ef8f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/TotalCountPanel.vue"
export default component.exports